// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1mNW1","tab":"Tabs_tab__2AsWe","tabActive":"Tabs_tabActive__3vPyK"};